import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useRequestStreets from '../../../queries/useRequestStreets';
import CellDataContainer from '../CellDataContainer/CellDataContainer';
import CellText from '../CellText/CellText';
import addressActions from '../../../actions/address.actions';
import { actions as newRequestAction } from '../../../containers/CreateRequest/new-request.actions';
import { actionConst } from '../../../containers/CreateRequest/new-request.constants';
import { createFullAddress } from '../../../helpers/createFullAddress';
import { Tooltip } from 'antd';

const RequestAddress = ({ request = {}, canChange = true }) => {
  const dispatch = useDispatch();

  const { userInfo } = useSelector((state) => state.authentication);

  const streets = useRequestStreets({ staleTime: Infinity });

  const regionName = request.regionName ? (
    <CellText>мкр. {request.regionName}</CellText>
  ) : null;

  const companyName = request.companyName ? (
    <CellText>{request.companyName}</CellText>
  ) : null;

  const handleAddressClick = (e) => {
    e.stopPropagation();
    dispatch(newRequestAction.setRequestId(request.id));
    dispatch(newRequestAction.applyAddrStreet(request.streetId));
    dispatch(
      newRequestAction.applyAddrBuilding(request.houseId, request.serviceId)
    );
    dispatch(newRequestAction.setAddrFlatValue(request.addressId));
    dispatch(newRequestAction.setSubserviceValue(request.serviceId));
    dispatch(newRequestAction.applyService(request.parentServiceId));
    dispatch(newRequestAction.applyPossWarranty(request.garantyId > 0));
    dispatch(
      newRequestAction.setWorkerValue(request.master && request.master.id)
    );
    dispatch(
      newRequestAction.setExecuterValue(request.executer && request.executer.id)
    );
    dispatch(
      addressActions.openAddressModal({ ...request, serviceOnly: false })
    );
  };

  const isActive =
    canChange && !request.paidServiceRequestId && userInfo.CanChangeAddress;

  useEffect(() => {
    if (streets?.data?.length) {
      dispatch({
        type: `${actionConst.FETCH_ADDR_STREET_REF}_FULFILLED`,
        payload: streets,
      });
    }
  }, [streets.data]);

  return (
    <CellDataContainer>
      <Tooltip title="Адрес">
        <CellText
          style={{ cursor: isActive ? 'pointer' : 'initial' }}
          onClick={isActive ? handleAddressClick : undefined}
        >
          {createFullAddress(request)}
        </CellText>
      </Tooltip>
      <Tooltip title="Район">
        {regionName}
      </Tooltip>
      <Tooltip title="Компания">
        {companyName}
      </Tooltip>
    </CellDataContainer>
  );
};

export default RequestAddress;
